import cook from 'vue-cookies'

export default {
  namespaced: true,
  state: cook.get('willingbot_store') ? cook.get('willingbot_store').common : {
    // RSA加密公钥
    publicKey: '',
    // 当前页面导航KEY
    pageKey: 'home',
    // 当前页面面包屑导航路径
    pagePath: [],
    // 展开的导航KEY合集
    openedKeys: [],
  },
  mutations: {
    updatePublicKey (state, key) {
      state.publicKey = key
    },
    updatePageInfo (state, pageInfo) {
      state.pageKey = 'home'
      state.pagePath = []
      state.openedKeys = []
      if (pageInfo) {
        state.pageKey = pageInfo.pageKey
        state.pagePath = pageInfo.pagePath
        state.openedKeys = pageInfo.openedKeys
      }
    },
  }
}
